export default __webpack_public_path__ + "assets/images/c10cbf730f4dffd0ad29a6626b7b1a54.png";